// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"a3a0f3aa","787":"c59a68d8"}[chunkId] + ".chunk.js";
};